<template>
  <v-container>
    <h1> Success! </h1>
    <v-col cols="auto">
      <v-row
        justify="space-between"
        align="center"
        class="mb-2"
      >
      <p>The checkout process has been completed! </p>
      </v-row>
      <v-row
        justify="space-between"
        align="center"
        class="mb-2"
      >
        <p>Please click <a :href="`/jobs`">here</a> to go back to the jobs dashboard.</p> 
      </v-row>
    </v-col>
  </v-container>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      stripe: '',
    };
  },
  async mounted() {
  },
  methods: {
  },
};
</script>